import { AppAreaConfig } from '@/funnels/@types'
import japaneseDietMale from './japanese-diet-male'
import japaneseDietFemale from './japanese-diet-female'

const appAreaConfig: AppAreaConfig = {
	appArea: 'japanese-diet',
	landing: {
		ids: ['loader-japanese-diet'],
		route: {
			path: '/japanese-diet',
			name: 'japanese-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-japanese-diet',
		route: {
			path: '/japanese-diet/ob/:page(.*)?',
			name: 'japanese-diet',
		},
		slug: 'japanese-diet',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			immediateRedirect: true,
			sex: {
				male: { appArea: japaneseDietMale },
				female: { appArea: japaneseDietFemale },
			},
		},
	},
}

export default appAreaConfig
